import { ref } from 'vue';
import api from '../api';

export const useUsersExists = () => {
  const loading = ref<boolean>(false);
  const errorMessage = ref<string>();
  /**
   * returns a record by username with value whether exists (true).
   *
   * - Not finding username in the record means backend probably modified response data.
   * - null return means errror. Make sure you check errorMessage.
   */
  const checkUsersExistsByUsernames = async (usernames: string[]): Promise<Record<string, boolean> | null> => {
    loading.value = true;

    try {
      const response = await api.user.exists({ usernames });
      return response.data.reduce<Record<string, boolean>>((acc, check) => {
        acc[check.username] = check.exists;
        return acc;
      }, {});
    } catch {
      errorMessage.value = `failed to check usernames`;
    } finally {
      loading.value = false;
    }

    return null;
  };

  return { checkUsersExistsByUsernames, loading, errorMessage };
};
